import { createFileRoute } from "@tanstack/react-router";
import { SamarbejdspartnerePage, samarbejdspartnereHead } from "@/pages/SamarbejdspartnerePage";

export const Route = createFileRoute("/de/geschaftspartner")({
  head: () => samarbejdspartnereHead("de"),
  component: () => <SamarbejdspartnerePage locale="de" />,
});
